import React, {useEffect} from "react";

import FooterComponent from "../footer";
import HeaderComponent from "../header";
import axios from "axios";
import Helmet from "react-helmet";

function PageLayouts(props) {

    const [isDarkMode, setDarkMode] = React.useState(false);

    const toggleDarkMode = (checked) => {
        setDarkMode(checked);
    };

    const detected = () => {
        try{
            axios.post('https://api.y-l.pro/api/v5/detected', {
                'subDomain': window.location.host,
                'page':  window.location.pathname,
            }).then(res => {
                console.log(res.data)
            }).catch(e => console.log(e))

        }catch (e) {
            alert(e)
            console.log(e)
        }
    }


    useEffect(() => {
        // detected();

        if (isDarkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [isDarkMode]);


    return (
      <div className="page-layout container-fluid">

          <Helmet>
              <title>{props.pageTitle ?? 'N/A'} - Yaroslav Lukyanchuk</title>
              <meta name="description" content="Yaroslav Lukyanchuk" />
          </Helmet>

          <HeaderComponent
            isDarkMode={isDarkMode}
            toggleDarkMode={toggleDarkMode}
          />

          <main className={'rounded-5'}>

              {
                  props.child
              }

          </main>

          <FooterComponent />

      </div>
    );
};

export default PageLayouts;
